import type { CSSProperties } from 'react';

const DEFAULT_SIZE = 18;

export const notificationBadgeStyle = (
  size: number | undefined,
  canGrow: boolean,
  anchorRadius?: number,
): CSSProperties => {
  const side = size ?? DEFAULT_SIZE;
  const box = canGrow
    ? { minWidth: side, height: side }
    : { width: side, height: side };
  if (anchorRadius === undefined) return box;
  const inset =
    Math.round(((1 - 1 / Math.SQRT2) * anchorRadius - side / 2) * 100) / 100;
  const offset = `${inset}px`;
  return { ...box, top: offset, right: offset };
};
